import { memo, useMemo } from 'react';

import { IMenuByTypesItem } from '@r1-frontend/api-domru/api-content/v2/menu/by-types/dto/IMenuByTypesItem';

import * as ST from './styled';

interface IProps {
    partner: IMenuByTypesItem,
    onDataLayerHandler: (menuType: 'Main' | 'Right', title: string) => void,
}

const PartnersMenuItem = ({ partner, onDataLayerHandler }: IProps): JSX.Element => {
    const isSvgIcon = useMemo(() => partner.image_icon?.indexOf('.svg') !== -1, [partner.image_icon]);

    return (
        <ST.MenuItemWrapper>
            {partner.image_icon && (
                isSvgIcon
                    ? <ST.PartnerSvgIcon
                        iconPath={partner.image_icon}
                        data-test='partner-svg'
                    />
                    : <ST.PartnerIcon>
                        <img
                            src={partner.image_icon}
                            alt='логотип партнёрского сервиса'
                            data-test='partner-img'
                        />
                    </ST.PartnerIcon>
            )}
            <ST.PartnerLink
                href={partner.link}
                onClick={() => onDataLayerHandler('Main', partner.title)}
                data-test='partner-link'
            >
                {partner.title}
            </ST.PartnerLink>
        </ST.MenuItemWrapper>
    );
};

export default memo(PartnersMenuItem);
